"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _UtilityService = require("../util/UtilityService.js");

var _UtilityService2 = _interopRequireDefault(_UtilityService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var us_instance = _UtilityService2.default.us_instance;

var Videojs = function () {
    function Videojs(player, collector) {
        _classCallCheck(this, Videojs);

        this.playerObj = player;
        this.dc = collector;
        this.loadstartSent = false;
        this.bytesChangeCount = 0;
        this.timeUpdateCount = 0;
    }

    _createClass(Videojs, [{
        key: "registerEventListeners",
        value: function registerEventListeners() {
            var self = this;
            this.playerObj.on("bytesChange", function (evt) {
                self.processEvent(evt.type);
            });
            this.playerObj.on("play", function (evt) {
                self.processEvent(evt.type);
            });
            this.playerObj.on("loadedmetadata", function (evt) {
                self.processEvent(evt.type);
            });
            this.playerObj.on("timeupdate", function (evt) {
                self.processEvent(evt.type);
            });
            this.playerObj.on("loadstart", function (evt) {
                self.processEvent(evt.type);
            });
            this.playerObj.on("playing", function (evt) {
                self.processEvent(evt.type);
            });
            this.playerObj.on("pause", function (evt) {
                self.processEvent(evt.type);
            });
            this.playerObj.on("ready", function (evt) {
                self.processEvent(evt.type);
            });
            this.playerObj.on("waiting", function (evt) {
                self.processEvent(evt.type);
            });
            this.playerObj.on("error", function (evt) {
                self.processEvent(evt.type);
            });
            this.playerObj.on("ended", function (evt) {
                self.processEvent(evt.type);
            });
        }
    }, {
        key: "processEvent",
        value: function processEvent(evt) {
            if (evt === null || evt === undefined) {
                return null;
            }
            var evtType = evt;
            if (evtType === "ended" || evtType === "stalled" || evtType === "error") {
                this.loadstartSent = false;
            }
            if (evtType === "load" || evtType === "begin" || evtType === "loadedmetadata" || evtType === "loadstart") {
                if (!this.loadstartSent) {
                    evtType = "loadstart";
                    this.loadstartSent = true;
                } else {
                    //we've already sent a loadstart event
                    return null;
                }
            }
            if (evtType === "timechanged") {
                evtType = "timeupdate";
            }
            if (evtType === "waiting") {
                evtType = "buffering";
            }

            //supress these
            if (evtType.toLowerCase() === 'loadedmetadata') {
                return null;
            }
            //every 50th byteschange
            if (evtType.toLowerCase() === 'byteschange') {
                if (this.bytesChangeCount < 50) {
                    this.bytesChangeCount++;
                    return null;
                } else {
                    this.bytesChangeCount = 0;
                }
            }
            //drop timeupdate to every 15 sec.
            //timeupdate fires every 250 ms
            if (evtType.toLowerCase() === 'timeupdate') {
                if (this.timeUpdateCount < 60) {
                    this.timeUpdateCount++;
                    return null;
                } else {
                    this.timeUpdateCount = 0;
                }
            }
            var data = {};
            if (evtType === 'loadstart') {
                if (this.playerObj !== undefined) {
                    data = us_instance.getStreamInfo(this.playerObj.currentSrc());
                }
            }
            if (evtType.indexOf('bytesChange') !== -1) {
                evtType = evtType.split(",")[0].toLowerCase();
            }
            this.dc.submitEvent(JSON.stringify({ T: 'qos', TT: evtType, da: data }));
        }
    }]);

    return Videojs;
}();

exports.default = Videojs;